import React from 'react';
import { withTranslation } from 'react-i18next';
import edita from 'assets/images/editar.png';
import desvincula from 'assets/images/desvincular.png';

const UnidadRow = (props) => {

    const handleDesvincular = (id) => {
        console.log('[handleDesvincular]', id);
        props.desvincularConfirm(props);
        //props.desvincular(id);
    }

    const handleFidelizar = (id) => {
        console.log('[handleFidelizar]', id);
        props.fidelizar(id);
    }
	
	return (
		<tr>
            <td><strong>{props.unidad}</strong></td>
            <td>{props.alias}</td>
            <td>{props.partido_partida}</td>
            <td>{props.razon_social}</td>
            <td>{props.direccion}</td>
            <td>{props.fidelizable && <a href="#" onClick={() => handleFidelizar(props)} className="editar"><img src={edita} alt="Editar" title="Editar" /></a>}</td>
            <td><a href="#" onClick={() => handleDesvincular(props)} className="desvincular"><img src={desvincula} alt="Desvincular" title="Desvincular"/></a></td>
        </tr>
    );
}

export default withTranslation()(UnidadRow);